import clsx from 'clsx';
import * as style from './ConvenientItem.css';
import { useDeviceType } from '@cian/ui-kit';

interface IConvenientItemProps {
  title: string;
  good: string;
  bad: string;
}

export const ConvenientItem: React.FC<IConvenientItemProps> = ({ title, good, bad }) => {
  const device = useDeviceType();

  return (
    <div
      className={clsx(
        style['item'],
        device !== 'desktop' && style['item-tablet'],
        device === 'phone' && style['item-phone'],
      )}
    >
      <div className={style['item-title']}>{title}</div>
      <div className={style['conditions']}>
        <div className={style['condition']}>
          <div className={clsx(style['success-icon'], style['icon'])} />
          <div className={style['text']}>{good}</div>
        </div>
        <div className={style['condition']}>
          <div className={clsx(style['error-icon'], style['icon'])} />
          <div className={style['text']}>{bad}</div>
        </div>
      </div>
    </div>
  );
};
